import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CorizeBaseComponent } from '../../models/base-corize-component';


@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent extends CorizeBaseComponent implements OnInit { 
  constructor(
    public dialog: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public msg: string) {
    super();
  }

    no(): void {
      this.dialog.close(false);
    }
    yes(): void {
      this.dialog.close(true);
    }

  ngOnInit() {
  }

}